import { css } from 'lit';
import { IxTimer } from './IxTimer.js';

export class IxTimerStyled extends IxTimer {
  static override styles = css`
    .timer-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    ix-icon {
      font-size: 16px;
      margin-top: 4px;
    }
  `;
}

window.customElements.define('ix-timer', IxTimerStyled);
